import DashboardRoutes from "@/routes/moduleRoutes/DashboardRoutes";
import type { RouteConfig } from "@/types/routestypes";
import MyTeamRoute from "@/routes/moduleRoutes/MyTeamRoute";
import AuthRoutes from "@/routes/moduleRoutes/AuthRoute";
import MyCustomerRoutes from "@/routes/moduleRoutes/MyCustomerRoutes";
import DealAndPipelineRoute from "@/routes/moduleRoutes/DealAndPipelineRoute";
import MyExpenseRoute from "@/routes/moduleRoutes/MyExpenseRoute";
import OrderManagementRoute from "./moduleRoutes/OrderManagementRoute";
import SettingRoute from "./moduleRoutes/SettingRoute";
import AttendanceRoute from "@/routes/moduleRoutes/AttendanceRoute";
import RosterPlanRoute from "./moduleRoutes/RosterPlanRoute";
import AssetAllocationRoute from "./moduleRoutes/AssetAllocationRoute";
import ReportsRoutes from "./moduleRoutes/ReportsRoutes";
import VisitForm from "@/routes/moduleRoutes/VisitFormRoute";
import DynamicFormRoute from "./moduleRoutes/DynamicFormRoute";
import LeaveManagementRoute from "./moduleRoutes/LeaveManagementRoute";
import MyTaskRoute from "./moduleRoutes/MyTaskRoute";
import ReferralProgramRoute from "./moduleRoutes/ReferraProgramRoute";

const routes: {
  publicRoutes: Record<string, RouteConfig>;
  privateRoutes: Record<string, RouteConfig>;
} = {
  publicRoutes: {
    AUTH: AuthRoutes,
  },
  privateRoutes: {
    DASHBOARD: DashboardRoutes,
    MY_CUSTOMERS: MyCustomerRoutes,
    MYTEAM: MyTeamRoute,
    DEALS_PIPELINE: DealAndPipelineRoute,
    ROSTER_PLAN: RosterPlanRoute,
    MY_TASK: MyTaskRoute,
    AttendanceRoute: AttendanceRoute,
    MY_EXPENSE: MyExpenseRoute,
    VISIT_FORM: VisitForm,
    DYNAMIC_FORM: DynamicFormRoute,
    LEAVE_MANAGEMENT: LeaveManagementRoute,
    ORDER_MANAGEMENT: OrderManagementRoute,
    REFERRAL: ReferralProgramRoute,
    ASSET_ALLOCATION: AssetAllocationRoute,
    REPORTS: ReportsRoutes,
    SETTINGS: SettingRoute,
  },
} as const;

export default routes;
